import { DesktopOutlined } from '@ant-design/icons';
import { Result } from 'antd';

/**
 * Screens moved to the desk (docs/changes/37): an old link or bookmark says
 * where the work is done now.
 */
export function MovedPage({ what }: { what: string }) {
  return (
    <div className="page">
      <Result
        icon={<DesktopOutlined />}
        title={`${what} تُعدَّل الآن من الحاسوب`}
        subTitle="افتح «مكتب الجمعية» على الحاسوب: قسم «الماء»."
      />
    </div>
  );
}
